import { getCookie } from '~/composables/useCommon';

/**
 * Spring Security CSRF — 레거시 JSP 폼의 `_csrf` 파라미터와 동일 값.
 * 쿠키 `XSRF-TOKEN`(Spring Boot 기본) 또는 `CSRF-TOKEN`, `meta[name="_csrf"]` 순으로 조회.
 */
export function getCsrfToken(): string {
  if (import.meta.server || typeof document === 'undefined') {
    return '';
  }

  const tryDecode = (raw: string | null): string => {
    if (!raw) return '';
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  };

  const fromXsrf = tryDecode(getCookie('XSRF-TOKEN'));
  if (fromXsrf) return fromXsrf;

  const fromCsrf = tryDecode(getCookie('CSRF-TOKEN'));
  if (fromCsrf) return fromCsrf;

  const meta = document.querySelector('meta[name="_csrf"]');
  const content = meta?.getAttribute('content');
  if (content) return content;

  return '';
}

/** URLSearchParams에 `_csrf`가 없을 때만 추가 */
export function appendCsrfToUrlSearchParams(params: URLSearchParams): URLSearchParams {
  const token = getCsrfToken();
  if (token && !params.has('_csrf')) {
    params.append('_csrf', token);
  }
  return params;
}

/** FormData에 `_csrf`가 없을 때만 추가 (multipart 저장 등) */
export function appendCsrfToFormData(formData: FormData): FormData {
  const token = getCsrfToken();
  if (token && !formData.has('_csrf')) {
    formData.append('_csrf', token);
  }
  return formData;
}
